import React from 'react'

const ChatIconLoginScreen = props => {
  return (
    <svg
      className={props.classProp}
      style={{ position: 'absolute', top: '65px', left: '70px' }}
      xmlns="http://www.w3.org/2000/svg"
      width="55"
      height="50"
      viewBox="0 0 55 50"
    >
      <defs>
        <path id="xz11yplyqa" d="M0 0h53.762v50H0z" />
      </defs>
      <g fill="none" fill-rule="evenodd">
        <g transform="translate(.608)">
          <mask id="l6zi3t80mb" fill="#fff">
            <use xlinkHref="#xz11yplyqa" />
          </mask>
          <path
            d="M4.997 38.274h5.428c.09 5.309-1 7.556-3.026 11.726 8.19-2.361 13.212-2.469 18.862-11.726H48.765c2.75 0 4.997-2.252 4.997-5.003V4.997C53.762 2.253 51.515 0 48.765 0H4.997C2.247 0 0 2.253 0 4.997V33.493c.12 2.648 2.319 4.781 4.997 4.781"
            fill="#FBFBFB"
            mask="url(#l6zi3t80mb)"
          />
        </g>
        <path
          d="M16.168 11.682h-4.86a2.114 2.114 0 0 1 0-4.227h4.86a2.114 2.114 0 1 1 0 4.227m27.501 0H26.737a2.114 2.114 0 0 1 0-4.227H43.67a2.114 2.114 0 1 1 0 4.227M43.67 21.25H11.308a2.114 2.114 0 0 1 0-4.226h32.36a2.114 2.114 0 1 1 0 4.227M28.241 30.82H11.309a2.114 2.114 0 0 1 0-4.228h16.932a2.114 2.114 0 1 1 0 4.227m15.428 0h-4.86a2.114 2.114 0 0 1 0-4.227h4.86a2.113 2.113 0 1 1 0 4.227"
          fill="#2A779A"
        />
      </g>
    </svg>
  )
}

export default ChatIconLoginScreen
